import type { LucideIcon } from 'lucide-react';
import {
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Link,
  ListOrdered,
  ListChecks,
  Heading1,
  Heading2,
  Heading3,
  Quote,
  Minus,
  Code,
  Image,
  HelpCircle,
} from 'lucide-react';
import { EditorAction } from './ContentEditor.actions';
import { Button } from '@/Domain/components/Shared/Button/Button';

type Props = {
  actions: EditorAction[];
};

const ICON_MAP: Record<string, LucideIcon> = {
  bold: Bold,
  italic: Italic,
  underline: Underline,
  strike: Strikethrough,
  link: Link,
  'ordered-list': ListOrdered,
  'bullet-list': ListChecks,
  'heading-1': Heading1,
  'heading-2': Heading2,
  'heading-3': Heading3,
  blockquote: Quote,
  'horizontal-rule': Minus,
  'code-block': Code,
  image: Image,
};

export const ContentEditorToolbar = ({ actions }: Props) => (
  <div className="flex flex-wrap gap-0.5 p-0.5 border border-border rounded-xl mb-2">
    {actions.map(({ command, icon, title }, index) => {
      const IconComponent = ICON_MAP[icon] ?? HelpCircle;
      return (
        <Button
          key={index}
          variant="white"
          size="xs"
          className="text-muted-foreground border-0"
          onClick={command}
          title={title}
        >
          <IconComponent className="h-3.5 w-3.5" />
        </Button>
      );
    })}
  </div>
);
